import React, { useCallback } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useAISuggestion } from '../../hooks/useAISuggestion';
import { AISuggestionDisplay } from './AISuggestionDisplay';
import { AISuggestionGenerator } from './AISuggestionGenerator';
import { ResponseErrorPanel } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
  },
  sectionIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  },
}));

interface AISuggestionSectionProps {
  eventId: string | undefined;
  entries?: any[];
}

export const AISuggestionSection: React.FC<AISuggestionSectionProps> = ({
  eventId,
  entries,
}) => {
  const classes = useStyles();
  const { suggestion, error, refetch, hasSuggestion } = useAISuggestion(eventId || null);

  const handleSuggestionGenerated = useCallback(() => {
    // Refetch to get the newly generated suggestion
    refetch();
  }, [refetch]);

  if (!eventId) {
    return null;
  }

  if (error) {
    return (
      <Box mb={3}>
        <Typography className={classes.sectionTitle}>
          <span className={classes.sectionIcon}>🤖</span>
          AI Error Analysis
        </Typography>
        <ResponseErrorPanel error={error} />
      </Box>
    );
  }

  return (
    <Box mb={3}>
      {hasSuggestion && suggestion ? (
        <AISuggestionDisplay suggestion={suggestion} />
      ) : (
        <AISuggestionGenerator
          eventId={eventId}
          entries={entries}
          onSuggestionGenerated={handleSuggestionGenerated}
        />
      )}
    </Box>
  );
};